module.exports = __webpack_public_path__ + "media/images/new-ui-images/pdfblack-8e9b93834dccf837fc34ba5ae0fa8073.svg";